import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, SIZES } from "@/lib/api";
import { Printer } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function SoleOrderPrint() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => { api.get(`/sole-orders/${id}`).then((r) => setOrder(r.data)).catch(() => setFailed(true)); }, [id]);

  if (failed) return <div className="p-10 text-red-600" data-testid="sole-order-print-not-found">Taban siparişi bulunamadı.</div>;
  if (!order) return <div className="p-10 text-gray-500">Yükleniyor...</div>;

  const groups = new Map();
  order.items.forEach((i) => {
    const k = `${i.sole_code}||${i.sole_color}`;
    if (!groups.has(k)) groups.set(k, { k, code: i.sole_code, color: i.sole_color, sizes: {}, total: 0 });
    const g = groups.get(k);
    g.sizes[i.size] = i.qty; g.total += i.qty;
  });
  const rows = [...groups.values()];
  const grand = rows.reduce((a, g) => a + g.total, 0);

  return (
    <div className="min-h-screen bg-white text-black" data-testid="sole-order-print-page">
      <div className="max-w-[1000px] mx-auto p-8 sm:p-12">
        <div className="flex justify-end mb-6 print:hidden">
          <button onClick={() => window.print()} data-testid="sole-order-print-btn"
            className="flex items-center gap-2 bg-[#D97706] hover:bg-[#B45309] text-white px-5 h-11 rounded-md font-display uppercase tracking-wide">
            <Printer className="w-4 h-4" /> Yazdır
          </button>
        </div>
        <div className="flex justify-between items-start border-b-2 border-black pb-4 mb-6">
          <div>
            <Logo dark className="text-4xl" subtitle="Ayakkabı Üretim" testId="print-logo" />
            <h1 className="font-display text-2xl font-extrabold uppercase tracking-tight mt-4" data-testid="print-title">Taban Sipariş Formu</h1>
          </div>
          <div className="text-right text-sm font-mono">
            <p>Sipariş No: <b data-testid="sole-order-print-no">{order.no}</b></p>
            <p>Tarih: {new Date(order.created_at).toLocaleDateString("tr-TR")}</p>
            {order.delivery_date && <p>İstenen Teslim: {order.delivery_date}</p>}
          </div>
        </div>
        <div className="mb-6 text-sm">
          <p className="text-[10px] font-mono uppercase tracking-widest text-gray-500">Taban Firması</p>
          <p className="text-lg font-semibold" data-testid="sole-order-print-supplier">{order.supplier}</p>
        </div>
        <table className="w-full text-sm border border-black">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-black px-2 py-1.5 text-left">Taban Kodu</th>
              <th className="border border-black px-2 py-1.5 text-left">Renk</th>
              {SIZES.map((s) => <th key={s} className="border border-black px-1 py-1.5 text-center w-10">{s}</th>)}
              <th className="border border-black px-2 py-1.5 text-right">Toplam</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((g) => (
              <tr key={g.k}>
                <td className="border border-black px-2 py-1.5 font-mono font-semibold">{g.code}</td>
                <td className="border border-black px-2 py-1.5">{g.color || "—"}</td>
                {SIZES.map((s) => <td key={s} className="border border-black px-1 py-1.5 text-center font-mono">{g.sizes[s] || ""}</td>)}
                <td className="border border-black px-2 py-1.5 text-right font-mono font-bold">{g.total}</td>
              </tr>
            ))}
            <tr className="font-bold">
              <td colSpan={12} className="border border-black px-2 py-1.5 text-right">GENEL TOPLAM</td>
              <td className="border border-black px-2 py-1.5 text-right font-mono" data-testid="sole-order-print-total">{grand}</td>
            </tr>
          </tbody>
        </table>
        {order.note && <p className="text-sm mt-4">Not: {order.note}</p>}
        <div className="grid grid-cols-2 gap-10 mt-16 text-sm text-center">
          <div className="border-t border-black pt-2">Siparişi Veren</div>
          <div className="border-t border-black pt-2">Taban Firması Onay</div>
        </div>
      </div>
    </div>
  );
}
